import { render, staticRenderFns } from "./Modal.vue?vue&type=template&id=188da090"
import script from "./Modal.vue?vue&type=script&lang=js"
export * from "./Modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tomi/Projects/ingeniAR/rrhh/Frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('188da090')) {
      api.createRecord('188da090', component.options)
    } else {
      api.reload('188da090', component.options)
    }
    module.hot.accept("./Modal.vue?vue&type=template&id=188da090", function () {
      api.rerender('188da090', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Worksectors/Modal.vue"
export default component.exports